<div class="panel_wrapper">
  <mat-expansion-panel (opened)="handleOpened()" (closed)="handleClosed()" hideToggle="true" class="pb-0">
      <mat-expansion-panel-header tabindex="-1" [collapsedHeight]="'auto'" [expandedHeight]="'auto'" class="main-header taxanomy-header p-0">
        <mat-panel-title class="align-items-center">
          <div class="taxanomy-number text-center row align-items-center"
          [style.background-color]="addAlpha(color, 0.2, 'xs')">
          <span [style.color]="color" class="font_size_16">{{strategy.title}}</span>
        </div>
        <div class="panel-header-text d-inline-block strategy_description_span">
          <app-dynamic-content
            [contentId]="'new-action-taxonomy-strategy-desc'"
            [htmlContent]="strategy.description">
          </app-dynamic-content>
        </div>
        <div class="arrows">
          <div tabindex="0" role="button" [attr.aria-expanded]="panelOpenState" [attr.aria-label]="(panelOpenState ? 'Collapse' : 'Expand') + ' ' + strategy.title">
          <svg [style.fill]="color" class="taxanomy-arrow-up" *ngIf="panelOpenState"
               xmlns="http://www.w3.org/2000/svg" width="49.61" height="49.61" viewBox="0 0 49.61 49.61">
               <path class="a"
               d="M24.805,49.61A24.805,24.805,0,0,1,7.265,7.265a24.805,24.805,0,0,1,35.08,35.08A24.643,24.643,0,0,1,24.805,49.61Zm0-45.735A20.929,20.929,0,1,0,45.735,24.805,20.953,20.953,0,0,0,24.805,3.876ZM38.2,21.511,35.464,18.77,24.805,29.429,14.147,18.77l-2.741,2.741,13.4,13.4Zm0,0"
               transform="translate(49.61 49.61) rotate(180)"/>
              </svg>

              <svg [style.fill]="color" class="taxanomy-arrow-down" *ngIf="!panelOpenState"
              xmlns="http://www.w3.org/2000/svg" width="49.61" height="49.61" viewBox="0 0 49.61 49.61">
              <path class="a"
              d="M24.805,49.61A24.805,24.805,0,0,1,7.265,7.265a24.805,24.805,0,0,1,35.08,35.08A24.643,24.643,0,0,1,24.805,49.61Zm0-45.735A20.929,20.929,0,1,0,45.735,24.805,20.953,20.953,0,0,0,24.805,3.876ZM38.2,21.511,35.464,18.77,24.805,29.429,14.147,18.77l-2.741,2.741,13.4,13.4Zm0,0"
              transform="translate(0)"/>
            </svg>
          </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <kla-new-action-taxonomy-action [actions]="strategy.list" [color]="color" [includeTier]="includeTier" [config]="config"></kla-new-action-taxonomy-action>
  </mat-expansion-panel>
</div>
